module.exports = ".create-destination-type{padding-top:10px}.create-destination-type>a{display:inline-block;margin-right:15px}\n"